import React  from 'react';
function TradeZakatTable({ result }) {
  return (
    <table >
      <thead>
        <tr>
          <th >Status</th>
          <th >Results</th>
        </tr>
      </thead>
      <tbody>
        <tr>
          <td>Zakat Obligation</td>
          <td>{result.silverZakatDuty === 'yes' ? 'You are obligated to pay Zakat' : 'You are not obligated to pay Zakat'}</td>
        </tr>
        <tr>
          <td>Total Assets</td>
          <td>{result.moneyAmout}</td>
        </tr>
        <tr>
          <td>Money Zakat Threshold</td>
          <td>{result.threshold}</td>
        </tr>
        <tr>
          <td>Amount of Zakat Obligatory to Be Paid (from Money)</td>
          <td>{result.tradeZakat}</td>
        </tr>
      </tbody>
    </table>
  );
}
export default TradeZakatTable;
